import { render } from "./ContentSection.vue?vue&type=template&id=e5ed9f8e&scoped=true"
import script from "./ContentSection.vue?vue&type=script&lang=js"
export * from "./ContentSection.vue?vue&type=script&lang=js"

import "./ContentSection.vue?vue&type=style&index=0&id=e5ed9f8e&scoped=true&lang=css"

import exportComponent from "D:\\lawstudio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5ed9f8e"]])

export default __exports__